<template>
  <form>
      <div class="row q-col-gutter-md">
        <div class="col col-xs-12 col-md-4 col-lg-5">
          <q-input
              v-model="categoryObj.title"
              :label="$t('helps.table_titles.category.title')"
              lazy-rules
              :error="categoryObj.errors.has('title')"
              :error-message="categoryObj.errors.get('title')"
              :rules="[ val => val && val.length > 0 || $t('helps.table_titles.category.title') + ' is required!']"
          />
        </div> <!-- TITLE -->
        <div class="col col-xs-12 col-md-4 col-lg-5">
          <q-input
            v-model="categoryObj.slug"
            label="Slug"
            lazy-rules
            :error="categoryObj.errors.has('slug')"
            :error-message="categoryObj.errors.get('slug')"
            :rules="[ val => val && val.length > 0 || $t('helps.table_titles.category.slug') + ' is required!']"
          />
        </div> <!-- SLUG -->
        <div class="col col-xs-12 col-md-4 col-lg-2">
          <q-input
            v-model="categoryObj.icon"
            :label="$t('helps.table_titles.category.icon')"
            lazy-rules
            :error="categoryObj.errors.has('icon')"
            :error-message="categoryObj.errors.get('icon')"
            :rules="[ val => val && val.length > 0 || $t('helps.table_titles.category.icon') + ' is required!']"
          />
        </div> <!-- ICON NAME -->
        <div class="col col-xs-12">
            <div>{{$t('helps.table_titles.category.description')}}:</div>
              <q-editor
                  v-model="categoryObj.description"
                  ref="editor"
                  :dense="$q.screen.lt.md"
                  :toolbar="[
              [
                {
                  label: $q.lang.editor.align,
                  icon: $q.iconSet.editor.align,
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['left', 'center', 'right', 'justify']
                },
                {
                  label: $q.lang.editor.align,
                  icon: $q.iconSet.editor.align,
                  fixedLabel: true,
                  options: ['left', 'center', 'right', 'justify']
                }
              ],
              ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
              ['token', 'hr', 'link', 'custom_btn'],
              ['print', 'fullscreen'],
              [
                {
                  label: $q.lang.editor.formatting,
                  icon: $q.iconSet.editor.formatting,
                  list: 'no-icons',
                  options: [
                    'p',
                    'h1',
                    'h2',
                    'h3',
                    'h4',
                    'h5',
                    'h6',
                    'code'
                  ]
                },
                {
                  label: $q.lang.editor.fontSize,
                  icon: $q.iconSet.editor.fontSize,
                  fixedLabel: true,
                  fixedIcon: true,
                  list: 'no-icons',
                  options: [
                    'size-1',
                    'size-2',
                    'size-3',
                    'size-4',
                    'size-5',
                    'size-6',
                    'size-7'
                  ]
                },
                {
                  label: $q.lang.editor.defaultFont,
                  icon: $q.iconSet.editor.font,
                  fixedIcon: true,
                  list: 'no-icons',
                  options: [
                    'default_font',
                    'arial',
                    'arial_black',
                    'comic_sans',
                    'courier_new',
                    'impact',
                    'lucida_grande',
                    'times_new_roman',
                    'verdana'
                  ]
                },
                'removeFormat'
              ],
              ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

              ['undo', 'redo']
            ]"
                  :fonts="{
              arial: 'Arial',
              arial_black: 'Arial Black',
              comic_sans: 'Comic Sans MS',
              courier_new: 'Courier New',
              impact: 'Impact',
              lucida_grande: 'Lucida Grande',
              times_new_roman: 'Times New Roman',
              verdana: 'Verdana'
            }">
              </q-editor>
              <p v-if="categoryObj.errors.has('description')" class="text-negative">
                  {{ categoryObj.errors.get('description') }}
              </p>
        </div> <!-- Description -->
      </div>
    </form>
</template>

<script>
import FileUploader from "../../components/FileUploader"
export default {
  name: 'Form',
  model: {
    prop: 'categoryObj'
  },
  props: {
    categoryObj: {
      type: Object,
      required: true
    }
  },
  computed: {},
  data() {
    return {
      file: null,
      imgSrc: null,
    }
  },
  methods: {
    insertImg() {
      const post = this.categoryObj
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.png, .jpg'
      input.onchange = _ => {
        const files = Array.from(input.files)
        new Post().uploadImage(files[0], data => {
          post.body += '<div align="center"><img src="' + data + '" /></div> <br/>'
        })
      }
      input.click()
    },
    submit() {
      this.$emit('submit')
    },
    addTag (val, done) {
      done(val, 'add-unique')
    },
    selectedFile(file) {
      this.categoryObj.images = []
      this.categoryObj.images = file
    },
    removeFiles(files) {
      files.forEach( file => {
        if(file.id !== undefined)
          this.categoryObj.removed_images.push(file.id)
      })
    },
  },
  updated() {
    this.$emit('change', this.categoryObj)
  },
  components: {FileUploader},
}
</script>

<style scoped>

</style>
